function Hero(){
    return (
        <div className="vw-90 d-flex flex-column justify-content-center align-items-center">
            <div className="w-90 d-flex flex-column" > 
                <img src="/image/events-hero.png" width="100%"/>
            </div>
        </div>
    )
    }
    
    export default Hero